export const SPACES_REQUEST = 'SPACES_REQUEST';
export const SPACES_SUCCESS = 'SPACES_SUCCESS';
export const SPACES_FAILURE = 'SPACES_FAILURE';
